import { PersonalInfo } from './personalinfo/personalinfo';
import { ClassSchedule } from './classschedule/classschedule';
import { ElectiveResult } from './elective/electiveresult';
import { ScoreQueryPage } from './score/scorequery';
import { FreeClassroom } from './freeclassroom/freeclassroom';
import { ModalContentPage } from './freeclassroom/freeclassroom';
export const TEACHING_INDEX = [
  PersonalInfo,
  ClassSchedule,
  ElectiveResult,
  ScoreQueryPage,
  FreeClassroom,
  ModalContentPage
]



// WEBPACK FOOTER //
// ./src/pages/application/teaching/index.ts